<!-- BEGIN #sidebar-right -->
<div id="sidebar-right" class="app-sidebar app-sidebar-end" data-bs-theme="dark">
  <!-- BEGIN sidebar scrollbar -->
  <ng-scrollbar class="h-100">
    <div class="p-3">
			<p class="text-white">Accordion</p>
			<div class="accordion" id="accordionSidebar">
				<div class="accordion-item bg-gray-700 text-white border-0 rounded-0">
					<h2 class="accordion-header bg-gray-900 rounded-0 d-flex align-items-center" id="heading1">
						<button class="accordion-button bg-gray-900 rounded-0 text-white pointer-cursor d-flex align-items-center py-2 px-3" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1">
							Accordion #1
						</button>
					</h2>
					<div id="collapse1" class="accordion-collapse collapse show" data-bs-parent="#accordionSidebar">
						<div class="accordion-body py-2 p-3">
							Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.
						</div>
					</div>
				</div>
				<div class="accordion-item bg-gray-700 text-white border-0 rounded-0">
					<h2 class="accordion-header bg-gray-900 rounded-0 d-flex align-items-center" id="heading2">
						<button class="accordion-button bg-gray-900 rounded-0 text-white pointer-cursor d-flex align-items-center py-2 px-3 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2">
							Accordion #2
						</button>
					</h2>
					<div id="collapse2" class="accordion-collapse collapse" data-bs-parent="#accordionSidebar">
						<div class="accordion-body py-2 p-3">
							Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.
						</div>
					</div>
				</div>
				<div class="accordion-item bg-gray-700 text-white border-0 rounded-0">
					<h2 class="accordion-header bg-gray-900 rounded-0 d-flex align-items-center" id="heading3">
						<button class="accordion-button bg-gray-900 rounded-0 text-white pointer-cursor d-flex align-items-center py-2 px-3 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse3">
							Accordion #3
						</button>
					</h2>
					<div id="collapse3" class="accordion-collapse collapse" data-bs-parent="#accordionSidebar">
						<div class="accordion-body py-2 p-3">
							Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.
						</div>
					</div>
				</div>
				<div class="accordion-item bg-gray-700 text-white border-0 rounded-0">
					<h2 class="accordion-header bg-gray-900 rounded-0 d-flex align-items-center" id="heading4">
						<button class="accordion-button bg-gray-900 rounded-0 text-white pointer-cursor d-flex align-items-center py-2 px-3 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse4">
							Accordion #4
						</button>
					</h2>
					<div id="collapse4" class="accordion-collapse collapse" data-bs-parent="#accordionSidebar">
						<div class="accordion-body py-2 p-3">
							Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.
						</div>
					</div>
				</div>
				<div class="accordion-item bg-gray-700 text-white border-0 rounded-0">
					<h2 class="accordion-header bg-gray-900 rounded-0 d-flex align-items-center" id="heading5">
						<button class="accordion-button bg-gray-900 rounded-0 text-white pointer-cursor d-flex align-items-center py-2 px-3 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse5">
							Accordion #5
						</button>
					</h2>
					<div id="collapse5" class="accordion-collapse collapse" data-bs-parent="#accordionSidebar">
						<div class="accordion-body py-2 p-3">
							Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.
						</div>
					</div>
				</div>
				<div class="accordion-item bg-gray-700 text-white border-0 rounded-0">
					<h2 class="accordion-header bg-gray-900 rounded-0 d-flex align-items-center" id="heading6">
						<button class="accordion-button bg-gray-900 rounded-0 text-white pointer-cursor d-flex align-items-center py-2 px-3 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse6">
							Accordion #6
						</button>
					</h2>
					<div id="collapse6" class="accordion-collapse collapse" data-bs-parent="#accordionSidebar">
						<div class="accordion-body py-2 p-3">
							Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.
						</div>
					</div>
				</div>
				<div class="accordion-item bg-gray-700 text-white border-0 rounded-0">
					<h2 class="accordion-header bg-gray-900 rounded-0 d-flex align-items-center" id="heading7">
						<button class="accordion-button bg-gray-900 rounded-0 text-white pointer-cursor d-flex align-items-center py-2 px-3 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse7">
							Accordion #7
						</button>
					</h2>
					<div id="collapse7" class="accordion-collapse collapse" data-bs-parent="#accordionSidebar">
						<div class="accordion-body py-2 p-3">
							Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.
						</div>
					</div>
				</div>
				<div class="accordion-item bg-gray-700 text-white border-0 rounded-0">
					<h2 class="accordion-header bg-gray-900 rounded-0 d-flex align-items-center" id="heading8">
						<button class="accordion-button bg-gray-900 rounded-0 text-white pointer-cursor d-flex align-items-center py-2 px-3 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse8">
							Accordion #8
						</button>
					</h2>
					<div id="collapse8" class="accordion-collapse collapse" data-bs-parent="#accordionSidebar">
						<div class="accordion-body py-2 p-3">
							Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.
						</div>
					</div>
				</div>
			</div>
		</div>
  </ng-scrollbar>
  <!-- END sidebar scrollbar -->
</div>
<div class="app-sidebar-bg app-sidebar-end"></div>
<div class="app-sidebar-mobile-backdrop app-sidebar-end">
	<a href="javascript:;" (click)="toggleAppSidebarEndMobile()" class="stretched-link"></a>
</div>
<!-- END #sidebar-right -->
